import React from 'react';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Text } from '@amzn/storm-ui-v3';
import { REPORT_CATEGORY } from '@urc-ui/utils/types';
import { useTranslateMapItem } from '@urc-ui/hooks/translate-map';
import { REPORT_CATEGORY_TRANSLATION_MAP } from '@urc-ui/utils/subscription-utils';
import { StyledCellWrapper } from '@urc-ui/components/styles';

export function ReportCategoryCell(props: ICellRendererParams) {
  const value = useTranslateMapItem(REPORT_CATEGORY_TRANSLATION_MAP, props.value as REPORT_CATEGORY);
  return (
    <StyledCellWrapper>
      <Text fontSize='small'>{value}</Text>
    </StyledCellWrapper>
  );
}
